import { createSelector } from 'reselect'
import { emptyArr, sortByKeyInsensitive } from 'util/arrays'
import { emptyObj, mapObject } from 'util/objects'

export const selectLabelsById = state => (state.labels || emptyObj).byId
export const selectLabelsByHashedIdMap = state =>
  (state.labels || emptyObj).byHashedId

export const selectLabelsByHashedId = createSelector(
  selectLabelsById,
  selectLabelsByHashedIdMap,
  (byId, byHashedId) => {
    return Object.keys(byHashedId).reduce((result, hashedId) => {
      // eslint-disable-next-line no-param-reassign
      result[hashedId] = byId[byHashedId[hashedId]]
      return result
    }, {})
  }
)

const selectLabelIdsByMailboxId = state => state.labels.byMailboxId || emptyArr

export const selectLabelsByMailboxId = createSelector(
  selectLabelIdsByMailboxId,
  selectLabelsById,
  (byMailbox, byId) => mapObject(ids => ids.map(id => byId[id]))(byMailbox)
)

export const selectLabelIds = createSelector(
  selectLabelsById,
  labels => labels && Object.keys(labels)
)

export const selectLabelHashedIds = createSelector(
  selectLabelsByHashedId,
  labels => labels && Object.keys(labels)
)

// FIME: terrible perf - always returns new object!
export const selectLabels = createSelector(selectLabelsById, labels => {
  if (!labels) return emptyArr
  return sortByKeyInsensitive(Object.values(labels), 'name')
})

export const selectCounts = state => state.labels.counts || emptyObj
